import { render, staticRenderFns } from "./SampleReceiveTable.vue?vue&type=template&id=9de3e86c"
import script from "./SampleReceiveTable.vue?vue&type=script&lang=js"
export * from "./SampleReceiveTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports